<template>
  <div>
    <my-asidebar v-bind:active-tab="'agency'"> </my-asidebar>

    <section class="dashboard-area">
      <top-bar></top-bar>
      <div class="dashboard-content-wrap">
        <div class="dashboard-bread dashboard--bread dashboard-bread-2">
          <div class="container-fluid">
            <div class="row align-items-center">
              <div class="col-lg-6">
                <div class="breadcrumb-content">
                  <div class="section-heading">
                    <h2 class="sec__title font-size-30 text-white">Acente {{ id }}</h2>
                  </div>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="breadcrumb-list text-right">
                  <ul class="list-items">
                    <li><a :href="basePath" class="text-white">Anasayfa</a></li>
                    <li><a :href="basePath+'/proforma-detail/'+id" class="text-white">Proforma</a></li>
                    <li>Detay</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <agency-payment-detail :payment-view="paymentView"/>

      </div>
    </section>

  </div>
</template>

<script>
import TopBar from "../component/common/TopBar";
import MyAsidebar from "../component/common/MyAsidebar";
import AgencyDetail from "../component/agency/AgencyDetail";
import ChangePasswordPopup from "../component/agency/AgenctChangePasswordPopup";
import Vue from "vue";
import ProformaDetail from "../component/agency/ProformaDetail.vue";
import AgencyInvoiceList from "../component/agency/AgencyInvoiceList.vue";
import AgencyPaymentDetail from "../component/agency/AgencyPaymentDetail.vue";

export default {
  name: "AgencyPaymentDetailPage",
  data:function (){
    return{
      id: this.$route.params.id,
      paymentView: null
    }
  },
  components: {
    AgencyPaymentDetail,
    AgencyInvoiceList, ProformaDetail, ChangePasswordPopup, AgencyDetail, MyAsidebar, TopBar},
  computed:{
    basePath:{
      get(){
        return this.$store.getters.getBasePath
      }
    },
    panelRights:{
      get(){
        return this.$store.getters.getPanelRightsMap;
      }
    }
  },
  mounted() {
    //TODO: ENABLE AUTH
    if(!this.panelRights["PANEL_INVOICE_ACTIONS"]) this.$router.push("/");

    if(this.$route.params.id !== undefined) {
      this.$store.dispatch("loadAgencyPaymentView", this.$route.params.id).then((response)=>{
        this.paymentView = response;
      });
    }
  }
}
</script>

<style scoped>

</style>